import styled from "styled-components";
import { colors } from "../../../theme";

export const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${({ $light }) => ($light ? colors.primary : colors.captions)};

  &::before {
    content: "";
    width: 2rem;
    height: 2px;
    border-radius: 2px;
    background: currentColor;
  }
`;

export const Heading = styled.h2`
  font-size: clamp(1.9rem, 3.6vw, 2.75rem);
  color: ${colors.textMain};
`;

export const BodyText = styled.p`
  font-size: 1.0625rem;
  line-height: 1.75;
  color: ${colors.textMuted};
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
